import { render } from "./HelloWorld.vue?vue&type=template&id=1a727449"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Documents\\adminncgm\\adminncgm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__